import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('MEASUREMENT INSTRUMENTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class MeasurementInstrumentsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'measurementInstruments' como el nombre del recurso a la clase base
    super('measurementInstruments');
    log.debug('Servicio de Instrumentos de Medición inicializado');
  }

}
